var React = require('react');

function IconMicronutrientsInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Micronutrients"),React.createElement("path",{"d":"M6.58 15.29h7.38l3.69-6.39-3.69-6.4H6.58L2.89 8.9zm8.83 2.5H5.14L0 8.9 5.14 0h10.27l5.14 8.9z","fill":"#fff","key":1})]);
}

IconMicronutrientsInline.defaultProps = {"width":"21","height":"18","viewBox":"0 0 20.55 17.79"};

module.exports = IconMicronutrientsInline;

IconMicronutrientsInline.default = IconMicronutrientsInline;
